@if(type !== 'CHANGE_STATUS') {

<app-page-breadcrumb [pageInfo]="pageInfo" [isModal]="isModal"></app-page-breadcrumb>

<div class="modal-body pt-4 mb-4">
    @if (addAppointFormData.length) {
    <app-form-generator #addAppointForm [formData]="addAppointFormData">
    </app-form-generator>
    }

    <div class="col-md-12 text-center">
        <div class="btn-group">
            <button noDoubleClick class="btn btn-success" (click)="saveAppointment()">Submit</button>
            <button class="btn btn-danger ml-2" (click)="close()">Cancel</button>
        </div>
    </div>
</div>
}

@if(type === 'CHANGE_STATUS') {

<app-page-breadcrumb [pageInfo]="changeStatusPageInfo" [isModal]="isModal">
</app-page-breadcrumb>

<!-- <div class="modal-body pt-4 mb-4"> -->
<div class="modal-body pt-4 mb-4 change-status-modal-body">
    <app-form-generator #changeStatusForm [formData]="changeStatusFormData"></app-form-generator>

    <div class="col-md-12 text-right mt-4">
        <button class="py-2 px-3 border rounded-4 status-button" (click)="changeStatus()">
            Update Status
        </button>
        <button class="py-2 px-3 border border-secondary-subtle rounded-4 mr-2 cancel-button ml-2" (click)="close()">
            Cancel
        </button>
    </div>
</div>
}